import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ListingService } from '../../../services/listing.service';
import { NotificationService } from '../../../services/notification.service';
import { EditformComponent } from '../../../shared/components/editform/editform.component';
import { ViewService } from '../../../services/view.service';
import { RecordService } from '../../../services/record.service';
import { LinkRelatedRecordComponent } from '../../../shared/components/widget/dialog/link-related-record/link-related-record.component';
import { LooseObject } from '../../../objects/loose-object';
import { filter, finalize, first } from 'rxjs/operators';
import { filled } from '../../../shared/utils/common';
import { get } from 'lodash-es';

@Component({
  selector: 'app-contract-list',
  templateUrl: './contract-list.component.html',
  styleUrls: ['./contract-list.component.scss'],
  providers: [ ListingService ],
})

export class ContractListComponent implements OnInit {

  @Input() strRecordId : string;
  @Input() strModule : string;

  arContracts: LooseObject[] = [];

  objModuleMappingId: object = {
    customers: 'customer_id',
    sites: 'site_id'
  };

  bLoading: boolean = false;

  totalRecords: number = 0;

  bPageLoaded: boolean = false;

  get isSites(): boolean {
    return this.strModule == 'sites';
  }

  get isCustomer(): boolean {
    return this.strModule == 'customers';
  }

  constructor(
    public listingService: ListingService,
    private dialog: MatDialog,
    private viewService: ViewService,
    private recordService: RecordService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.fetchList('default');
  }

  fetchList(page: string = '') {
    let strModule = 'contracts';
    let objFilter = {};

    if (this.isCustomer) {
      objFilter = {
        customer_id: this.strRecordId
      };
    }

    if (this.isSites) {
      strModule = 'contract_sites';
      objFilter = {
        site_id: this.strRecordId
      };
    }

    this.arContracts = [];
    this.bLoading = true;

    const objPagination = this.listingService.beforeFetching(page);
    this.listingService.fetchData(
      JSON.stringify(objPagination['objPage']),
      strModule,
      JSON.stringify(objFilter)
    ).pipe(
      finalize(() => this.bLoading = false)
    ).subscribe(response => {
      this.arContracts = response['data'].map( data => {
        data.active_text = data.active == true ? 'active' : 'inactive';
        return data;
      });
      this.totalRecords = response['total_records'];
      this.listingService.afterFetching(response, page);
      this.bLoading = false;
      this.bPageLoaded = true;
    });
  }

  openForm(record: LooseObject = {}) {
    let strId = get(record, 'id');
    if (this.isSites) {
      strId = get(record, 'contract_id');
    }
    let objSiteDialog = this.dialog.open(EditformComponent, this.recordService.compilePopUpConfig({
      arData: {
        module : this.strModule
      },
      strModule: 'contracts',
      strId: strId,
      strMode: (strId) ? 'edit' : 'add'
    }));

    objSiteDialog.afterClosed().pipe(
      first(),
    ).subscribe( response => {
      if (response !== undefined && response.status == 'save') {
        setTimeout(() => this.fetchList('default'), response.data === 'record_update_success' ? 0 : 3500);
      }
    });
  }

  deleteRecord(record: LooseObject = {}) {
    const strId = get(record, 'id');
    this.notificationService.sendConfirmation(this.isSites ? 'unlink_site_confirmation' : 'confirm_delete')
      .pipe(
        filter(confirmation => confirmation.answer == true)
      ).subscribe( () => {
        let strDeleteModule = 'contracts';
        if (this.isSites) {
          strDeleteModule = 'contract_sites';
        }

        this.recordService.deleteRecord(strDeleteModule, strId).subscribe( response => {
          if (this.isSites) {
            this.notificationService.notifySuccess('record_unlink_success')
          } else {
            this.notificationService.notifySuccess('record_delete_success', {
              header: 'deleted_successful',
            });
          }
          this.fetchList('default');
        })
      });
  }

  recordDialog() {
    let objDefaultRecord = {};
    if (this.isCustomer) {
      objDefaultRecord = {
        customer_id: get(this.viewService.objRecord, 'record_details.id'),
        customer_text: get(this.viewService.objRecord, 'record_details.customer_text'),
      }
    }

    if (this.isSites) {
      objDefaultRecord = {
        customer_id: get(this.viewService.objRecord, 'record_details.customer_id'),
        customer_text: get(this.viewService.objRecord, 'record_details.customer_text'),
      }
    }

    let objRecordDialog = this.dialog.open(EditformComponent, this.recordService.compilePopUpConfig({
      arData: objDefaultRecord,
      strModule: 'contracts',
      strMode: 'add'
    }));

    objRecordDialog.afterClosed().pipe(
      first(),
    ).subscribe(editRecordData => {
      if (filled(editRecordData) && editRecordData.status == 'save') {

        if (this.isSites) {
          let strSiteId = get(editRecordData, 'data.id');
          if (filled(strSiteId)) {

            this.notificationService.sendConfirmation('link_site_confirmation').pipe(
            ).subscribe( (response) => {
              if (response.answer === true) {

                this.recordService.linkRecord('contract_sites', [
                  {
                    contract_id: this.strRecordId,
                    site_id: strSiteId,
                  }
                ]).subscribe( response => {
                  this.notificationService.notifySuccess( response.status == 200
                    ? 'link_record_successfully'
                    : 'content_report_error'
                  );
                  setTimeout(() =>
                    this.fetchList() , response.status == 200 ? 3500 : 0
                  )
                })
              } else {
                setTimeout(() =>
                  this.fetchList() , editRecordData.data === 'record_update_success' ? 0 : 3500
                )
              }
            });
          }
        } else {
          setTimeout(() => this.fetchList() , 1500);
        }
      }
    });
  }
}